export const convertIsoDateStringToDate = (isoDate) => {
    if (!isoDate)
        return null;
    return new Date(isoDate);
};
export const multiLangStringOptions = ['de', 'en'];
export var Language;
(function (Language) {
    Language["DE"] = "DE";
    Language["EN"] = "EN";
})(Language || (Language = {}));
export var Gender;
(function (Gender) {
    Gender["MALE"] = "MALE";
    Gender["FEMALE"] = "FEMALE";
})(Gender || (Gender = {}));
